<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import Permission from './Permission.vue';

export default defineComponent({
  name: 'Home',
  components: {
    Permission
  },
  computed: {
    ...mapGetters([
      'permission'
    ])
  },
  created () {
    if (this.$route.query.type) {
      this.changeType(this.$route.query.type);
    } else {
      this.changeType('chat');
    }
  },
  methods: {
    ...mapActions([
      'changePermission',
      'changeType'
    ]),
    changeValue (event: boolean) {
      this.changePermission(event);
    }
  }
});
</script>

<template>
  <div class="home">
    <div class="body">
      <permission/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  background-color: $survey-background-color;

  .body {
    height: 100vh;
    overflow: auto;
    background-color: $survey-background-color;
  }
  .button {
    width: 150px;
  }
  .checkbox {
    width: 90%;
  }
  .permission-footer {
    height: 22vh;
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 15px;
    height: 15vh;
  }
}

.header-text {
  font-size: 25px;
}
</style>
